import { useCallback } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import {
    cpOrderInvoicesDetailsModelAtom,
    cpOrderInvoicesDetailsPageStateAtom,
} from './cp_order_invoices_details_atoms';
import cpOrderInvoicesRepo from '../data/cpOrderInvoicesRepo';

export const useFetchInvoice = (): ((id: string) => Promise<void>) => {
    const setModel = useSetImmerAtom(cpOrderInvoicesDetailsModelAtom);
    const setState = useSetImmerAtom(cpOrderInvoicesDetailsPageStateAtom);

    return useCallback(
        async (id: string): Promise<void> => {
            setState(draft => {
                draft.waiting = true;
            });
            try {
                const res = await cpOrderInvoicesRepo.getDetail(id);
                setModel(() => res);
            } catch (err: any) {
                console.error(err);
            } finally {
                setState(draft => {
                    draft.waiting = false;
                });
            }
        },
        [setModel, setState],
    );
};
